import { Skeleton } from "@mantine/core";
import { useParams } from "@tanstack/react-router";

import { useGetCatalog } from "../../../api/generated/endpoints/generation/generation";
import { ErrorAlert } from "../../../platform/ErrorAlert";
import { CreateFrame } from "./CreateFrame";
import classes from "./create.module.css";
import { RecentResults } from "./RecentResults";
import { VideoForm } from "./VideoForm";

/** The prototype's `#create-video`: its actions over the composer, then the recent results. */
export function CreateVideoScreen() {
  const { teamId, brandId } = useParams({
    from: "/signed-in/teams/$teamId/brands/$brandId/home2/create-video",
  });
  const catalog = useGetCatalog();
  const composer = catalog.isError ? (
    <ErrorAlert error={catalog.error} />
  ) : catalog.data === undefined ? (
    <Skeleton className={classes.composerSkeleton} />
  ) : (
    // A brand's own draft, as the Studio's composer is keyed (decision 20).
    <VideoForm key={brandId} catalog={catalog.data} />
  );
  return (
    <CreateFrame
      composer={composer}
      results={<RecentResults teamId={teamId} brandId={brandId} medium="video" noun="video" />}
    />
  );
}
